﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadTextField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadTextField, eOutputFieldType.cadText)
export class CadTextField extends OutputField implements ICadTextField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public height: number;
    public insertionPointX: number;
    public insertionPointY: number;
    public insertionPointZ: number;
    public value: string;
}
